import { z } from 'zod'

// #12 - periodieke klant-beoordeling (monteurs + samenwerking).
//
// LET OP (escalatie): de score-schaal (1-5) en de VOORBEELD-criteria zijn een
// aanbeveling die aansluit op ClientSatisfactionScore; de exacte criteria/schaal
// + de precieze momenten (cadans) moeten met Jelle bevestigd worden. De criteria
// zijn daarom instelbaar (ClientBeoordelingCriterium, isVoorbeeld=true) en de
// cadans per klant aanpasbaar (ClientBeoordelingConfig).

export type ClientBeoordelingType = 'MONTEUR' | 'SAMENWERKING'
export type ClientBeoordelingStatus = 'OPEN' | 'INGEVULD' | 'GEMIST'

// Gedeeld submit-schema: per criterium een score 1-5 + optionele toelichting.
// Eén bron voor API (parse) + klant-form (client-side validatie).
export const clientBeoordelingScoreSchema = z.object({
  criteriumId: z.string().min(1),
  score: z.number().int().min(1).max(5),
  toelichting: z.string().trim().max(2000).optional(),
})

export const clientBeoordelingSubmitSchema = z.object({
  scores: z.array(clientBeoordelingScoreSchema).min(1),
})
export type ClientBeoordelingSubmitInput = z.infer<
  typeof clientBeoordelingSubmitSchema
>
